<template>
  <Modal
    v-model:visible="isVisible"
    class="line-item-removed-modal"
    :header="t('common.removeParam', { param: t('lineItems.lineItems') })"
    size="sm"
    @keypress.enter="onConfirm"
    @keypress.esc="onCancel"
  >
    <p>
      {{ modalMessage }}
    </p>

    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.cancel')"
        @click="onCancel"
      />
      <RygenButton
        mode="secondary"
        icon="pi pi-save"
        :label="t('common.confirm')"
        @click="onConfirm"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { PropType, computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentLineItem } from '@/model';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  removedLineItem: {
    type: Object as PropType<ShipmentLineItem>,
    default: undefined,
  },
  isShipOrderSplit: {
    type: Boolean,
    default: () => false,
  },
});
const { removedLineItem, isShipOrderSplit } = toRefs(props);
const emit = defineEmits<{
  (event: 'cancel'): void;
  (event: 'confirm', removedLineItem: ShipmentLineItem): void;
}>();

const { t } = useI18n();

const modalMessage = computed(() => {
  if (isShipOrderSplit.value) {
    return t('lineItems.splitShipOrderModalMessage', {
      shipOrderId: removedLineItem?.value?.shipOrderId,
    });
  }
  return t('lineItems.removeOrderModalMessage', {
    orderId: removedLineItem?.value?.orderId,
  });
});

const onCancel = () => {
  emit('cancel');
  isVisible.value = false;
};

const onConfirm = () => {
  if (removedLineItem?.value) {
    emit('confirm', removedLineItem.value);
  }
  isVisible.value = false;
};
</script>
